export const PRICE = '23 USD'
export const PAYMENT_NOTE = 'One-Time Payment • Digital Access'

export const BRAND = 'Brow Instructor Ready™'

export const heroIndicators = [
  '6 Professional Volumes',
  '5 Practical Bonuses',
  'Created Specifically for Brow Educators',
]

/** Section 4 — real Volume 2 pages, in the requested order. */
export const previewPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/snUMSpiBUHoMAf4mXmHKPH/page41-41.webp',
    page: 'Page 41',
    title: 'Common Mapping Mistakes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5shGpJVc3e9nFcv1xEpAmv/page19-19.webp',
    page: 'Page 19',
    title: 'Natural → Overcorrected → Professionally Balanced',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vRMcQVpws9S7LiDF9YTnfR/page23-23.webp',
    page: 'Page 23',
    title: 'Sparse Brows — Corrective Design',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3iKpQx8VPmAyhCPuQ4KXyo/page20-20.webp',
    page: 'Page 20',
    title: 'What Causes Natural Asymmetry?',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/de2BADBrXdUWCsNPaTJC9U/page45-45.webp',
    page: 'Page 45',
    title: 'Brow Mapping Sequence',
  },
]

/** Section 5 — pain identification. */
export const painPoints = [
  { text: 'I spend hours preparing every class.', tag: 'Preparation time', tint: '#F6D3D6' },
  {
    text: 'I know exactly what to do… but sometimes struggle to explain WHY to my students.',
    tag: 'Explaining the why',
    tint: '#CFE0F0',
  },
  {
    text: 'I keep recreating materials for every new training.',
    tag: 'Repetition',
    tint: '#D6E4CB',
  },
  {
    text: 'My students know the steps, but still struggle to make professional decisions.',
    tag: 'Student judgment',
    tint: '#DDD4F0',
  },
  {
    text: 'I want my training to feel as professional as my expertise.',
    tag: 'Professional image',
    tint: '#F6E3B6',
  },
]

/** Section 6 — before vs. with. */
export const beforeList = [
  'Searching everywhere for information',
  'Preparing every lesson separately',
  'Finding examples at the last minute',
  'Improvising student exercises',
  'Struggling to assess progress',
  'Repeating the same preparation before every training',
]

export const withList = [
  'Structured educational progression',
  'Visual concepts you can reference',
  'Analysis and correction frameworks',
  'Practice and real-world cases',
  'Student assessment resources',
  'A system designed specifically for educators',
]

export const prepFramework = ['Open', 'Choose', 'Prepare', 'Teach']

/** Section 7 — the 6 core volumes, colored like their covers. */
export const volumes = [
  {
    number: 1,
    series: true,
    title: 'Brow Foundations, Client Analysis & Consultation',
    description: 'Foundations, brow analysis and client consultation.',
    cover: '#F3E3D2',
  },
  {
    number: 2,
    title: 'Brow Mapping, Symmetry & Corrective Design Mastery',
    description: 'Mapping, natural asymmetry and corrective design.',
    cover: '#F6D3D6',
  },
  {
    number: 3,
    title: 'Professional Brow Shaping & Sculpting System',
    description: 'Shaping, sculpting and better removal decisions.',
    cover: '#CFE0F0',
  },
  {
    number: 4,
    title: 'Brow Color, Tinting & Henna Mastery',
    description: 'Color principles, shade decisions, tint and henna.',
    cover: '#F6E3B6',
  },
  {
    number: 5,
    title: 'Brow Lamination Mastery & Troubleshooting',
    description: 'Hair direction, lamination and troubleshooting.',
    cover: '#D6E4CB',
  },
  {
    number: 6,
    title: 'The Brow Educator Teaching & Assessment System',
    description: 'Methodology, feedback, progression and assessment.',
    cover: '#DDD4F0',
  },
]

/** Section 8 — what teaching brows actually involves. */
export const teachingSkills = [
  { word: 'Analyze', line: 'Read faces, growth and natural asymmetry.' },
  { word: 'Explain', line: 'Put the why into clear words.' },
  { word: 'Demonstrate', line: 'Show the decision, step by step.' },
  { word: 'Practice', line: 'Move students from watching to doing.' },
  { word: 'Correct', line: 'Fix the reasoning, not just the result.' },
  { word: 'Assess', line: 'Measure real skill progression.' },
]

/** Section 9 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus #1',
    title: 'The Brow Visual Teaching Library™',
    description:
      '100+ professional visual references designed to help explain difficult brow concepts more clearly.',
    accent: '#F6D3D6',
  },
  {
    number: 'Bonus #2',
    title: 'The Real-World Brow Case Study Vault™',
    description:
      '50+ realistic client scenarios designed to develop analysis, judgment and professional decision-making.',
    accent: '#CFE0F0',
  },
  {
    number: 'Bonus #3',
    title: 'The Student Practice & Skill-Building Lab™',
    description:
      'Progressive exercises that move students from recognition and guided practice toward independent decisions.',
    accent: '#D6E4CB',
  },
  {
    number: 'Bonus #4',
    title: 'The Brow Troubleshooting & Correction Atlas™',
    description:
      'A visual reference library of common mistakes, possible causes, professional responses and prevention strategies.',
    accent: '#DDD4F0',
  },
  {
    number: 'Bonus #5',
    title: 'The 5-Minute Brow Class Prep Toolkit™',
    description:
      'Practical planning tools to help organize objectives, demonstrations, exercises and assessments without starting from scratch.',
    accent: '#F6E3B6',
    featured: true,
  },
]

/** Section 10 — the 5-minute class prep sequence. */
export const prepSteps = [
  'Choose the topic',
  'Define the objective',
  'Select the lesson',
  'Choose the demonstration',
  'Add student practice',
  'Select the assessment',
]

/** Section 11 — who it is for. */
export const audience = [
  'You are a Brow Educator or Brow Instructor',
  'You are an experienced Brow Artist beginning to teach',
  'You own or work within a Beauty Academy',
  'You offer private or group brow training',
  'You want more structure behind your classes',
  'You spend too much time preparing educational materials',
  'You want your student experience to feel more professional',
]

/** Section 12 — everything included, right above the checkout button. */
export const includedItems = [
  { name: '6 Professional Core Volumes', detail: 'Foundations → teaching & assessment', primary: true },
  { name: 'The Brow Visual Teaching Library™', detail: '100+ visual references' },
  { name: 'Real-World Brow Case Study Vault™', detail: '50+ client scenarios' },
  { name: 'Student Practice & Skill-Building Lab™', detail: 'Progressive exercises' },
  { name: 'Brow Troubleshooting & Correction Atlas™', detail: 'Mistakes, causes & fixes' },
  { name: '5-Minute Brow Class Prep Toolkit™', detail: 'Class planning tools' },
]

/** Section 13 — the old way. */
export const oldWay = ['Search', 'Prepare', 'Organize', 'Create', 'Correct', 'Repeat']

export const faqs = [
  {
    question: 'Is this for beginner Brow Artists?',
    answer:
      'Brow Instructor Ready™ is primarily designed for Brow Educators, instructors, trainers and experienced Brow Artists who teach or want to structure their education more professionally.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. Brow Instructor Ready™ is a digital product.',
  },
  {
    question: 'What language is the material in?',
    answer: 'The main educational material is in English.',
  },
  {
    question: 'Can I use this to prepare my brow training?',
    answer:
      'Yes. The system is designed as a professional resource to support class preparation, teaching, student practice, troubleshooting and assessment.',
  },
  {
    question: 'Is it only about brow mapping?',
    answer:
      'No. The system covers foundations, consultation, mapping, symmetry, corrective design, shaping, color, tinting, henna, lamination, troubleshooting, teaching and assessment.',
  },
  {
    question: 'Do I need to be an experienced instructor?',
    answer:
      'Not necessarily. It can also help experienced Brow Artists who are beginning to teach develop a clearer educational structure.',
  },
  {
    question: 'Are the resources editable?',
    answer:
      'No. The resources are delivered as finished digital materials. No Word documents or editable templates are required.',
  },
]
